<template>
  <div class="w-full flex items-start justify-center md:mt-24 pb-64">
    <login-form-component class="mt-10" />
  </div>
</template>

<script>
export default {
  props: [],
  mounted() {
    this.$nextTick(function () {
      this.$store.commit('setCurrentPath', 'login');
    })
  },
  methods: {
  },
}
</script>
